import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import {
  GHOST_SIGNUP_BUTTON_COLOR,
  GHOST_SIGNUP_LABEL,
  GHOST_SIGNUP_SCRIPT,
  GHOST_SIGNUP_SITE,
} from '../links'

const Footer = () => {
  useEffect(() => {
    const host = document.getElementById('ghost-signup-here')
    if (!host || host.dataset.loaded === 'true') return

    const script = document.createElement('script')
    script.src = GHOST_SIGNUP_SCRIPT
    script.async = true
    script.setAttribute('data-label-1', GHOST_SIGNUP_LABEL)
    script.setAttribute('data-button-color', GHOST_SIGNUP_BUTTON_COLOR)
    script.setAttribute('data-button-text-color', '#FFFFFF')
    script.setAttribute('data-site', GHOST_SIGNUP_SITE)
    script.setAttribute('data-locale', 'en')

    host.dataset.loaded = 'true'
    host.appendChild(script)

    return () => {
      host.replaceChildren()
      delete host.dataset.loaded
    }
  }, [])

  return (
    <footer id="site-footer" className="bg-[#434549] text-white pb-[env(safe-area-inset-bottom)]">
      <div className="container-custom px-4 sm:px-6 lg:px-8 pt-12 md:pt-[125px] pb-12 md:pb-[125px]">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-12 items-start">
          {/* Left: SF Heritage logo + contact */}
          <div className="space-y-6">
            <Link to="/" aria-label="San Francisco Heritage" className="inline-block w-[70%] max-w-[320px] md:max-w-[55%] md:w-auto">
              <img
                src="/content/images/sfheritage-logo-white.png"
                alt="San Francisco Heritage"
                className="w-full h-auto"
                width={600}
                height={100}
              />
            </Link>
            <p className="text-white leading-relaxed break-words">
              2007 Franklin St, San Francisco, CA 94109
              <br />
              <a href="tel:415-441-3000" className="text-[#f9f9fb] hover:underline inline-flex min-h-11 items-center">
                415-441-3000
              </a>
              <br />
              <a href="mailto:info@sfheritage.org" className="text-[#f9f9fb] hover:underline inline-flex min-h-11 items-center break-all">
                info@sfheritage.org
              </a>
            </p>
          </div>

          {/* Right: Special City newsletter */}
          <div className="space-y-4 min-w-0">
            <p className="text-white">
              Get news about the Doolan-Larson House by subscribing to San Francisco Heritage&rsquo;s
              Special City newsletter:
            </p>
            <div
              id="ghost-signup-here"
              className="w-full max-w-[440px] md:mx-auto"
              style={{ minHeight: 58 }}
            />
          </div>
        </div>
      </div>

      <div className="container-custom px-4 sm:px-6 lg:px-8 pb-3.5">
        <p className="font-sora text-[13px] font-normal leading-[22px] tracking-normal text-white">
          Copyright 2026 SF Heritage
        </p>
      </div>
    </footer>
  )
}

export default Footer
